export const LOCAL_URL = 'http://localhost:3000'
export const DEV_URL = 'https://pwa-dev.rikitwo.co.uk'
export const RELEASE_URL = 'https://pwa-stg.rikitwo.co.uk'

// TODO: Change to PROD env url once env is created
export const PRODUCTION_URL = 'https://pwa-stg.rikitwo.co.uk'
